import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { Tooltip } from "./Tooltip.js";
function RightIcon({
  children,
  tooltip
}) {
  return (tooltip == null ? void 0 : tooltip.length) ? /* @__PURE__ */ jsx(Tooltip, {
    content: tooltip,
    position: "top-right",
    children: (triggerProps) => /* @__PURE__ */ jsx(RightElementIcon, {
      ...triggerProps,
      children
    })
  }) : /* @__PURE__ */ jsx(RightElementIcon, {
    children
  });
}
const RightElementIcon = styled.div.withConfig({
  displayName: "RightElementIcon",
  componentId: "sc-143q2i3-0"
})(["&:last-child{margin-right:calc(", " * -1);}"], token.spacing2);
export {
  RightIcon
};
//# sourceMappingURL=RightIcon.js.map
